// The default texts more than one search widget pack shares, one value per language, so the
// dropdown, modal and results packs can't drift apart. Two SEPARATE literals, so a bundle takes
// only the one its widgets read (results-only bundles carry no search-box placeholder). Pure data
// — see ./locale.ts.
//
// Sources:
//   - INPUT_PLACEHOLDERS: cs / sk / en from the customers' configs (most common value per
//     language); de from freshlabels-de.
//   - NO_RESULTS_MESSAGES: cs / sk the customers' second most common wording ("…zkuste to jinak" /
//     "…skúste to inak": retrying the same query won't help, so not "…znovu" / "…znova"); en from
//     the customers; de drafted in the formal register (freshlabels-de, the only German config,
//     uses the informal "du").

import type { TextPacks } from "./locale.ts";

// The search box placeholder (dropdown `inputPlaceholder`, modal `inputPlaceholder`).
export const INPUT_PLACEHOLDERS = {
  cs: "Napište, co hledáte",
  sk: "Napíšte, čo hľadáte",
  en: "Search",
  de: "Suchen",
} as const satisfies TextPacks<string>;

// `noResultsFoundMessage` (dropdown, modal, results).
export const NO_RESULTS_MESSAGES = {
  cs: "Nic jsme nenašli, zkuste to jinak",
  sk: "Nič sme nenašli, skúste to inak",
  en: "Nothing found, try something else",
  de: "Leider nichts gefunden. Versuchen Sie es mit einem anderen Suchbegriff.",
} as const satisfies TextPacks<string>;
